// How an airport is named where the transfer step lists airports - QA doc docs/features/iway-transfers/qa.md R-HT24 (Amiran 09.10.2026: dev holds
// repeated core terminals - Turkey has six visible "Antalya Airport" rows (AYT, *AYT, AYT1, AYT2, AYTD, DELETED_AYT1) - and a list of names alone
// showed six identical rows). Data-driven: the name and the code exactly as the core holds them, nothing grouped, nothing hidden.
import { Terminal } from '@appTypes/api.types';

/** "Antalya Airport (AYT2)"; the code alone when the terminal has no name, the name alone when it has no code. */
export const terminalLabel = (terminal: Pick<Terminal, 'terminalName' | 'terminalCode'> | null | undefined): string => {
  const name = terminal?.terminalName?.trim() ?? '';
  const code = terminal?.terminalCode?.trim() ?? '';
  if (name && code) return `${name} (${code})`;
  return name || code;
};

/** The terminals with their label, in the order given. */
export const terminalOptions = <T extends Pick<Terminal, 'terminalName' | 'terminalCode'>>(
  terminals: readonly T[] | null | undefined
): (T & { label: string })[] => (terminals ?? []).map((t) => ({ ...t, label: terminalLabel(t) }));
